module.exports = __webpack_public_path__ + "img/V27.5fe94e78.jpg";